import { data } from 'react-router-dom';
import { get, post, put, del } from './api';


// xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx Order Details xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx

//  Create a new order with image
export const createOrder = (data) => {
  return post('/orders', data);
};

export const getAllOrders = (params = {}) => {
  const query = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      query.append(key, value);
    }
  });

  return get(`/orders?${query.toString()}`);
};

export const getAllCakeOrders = (params = {}) => {
  const query = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      query.append(key, value);
    }
  });

  return get(`/orders/cake-orders?${query.toString()}`);
};

//  Get a order by ID
export const getOrderById = (id) => {
  return get(`/orders/${id}`);
};

//  Update a order
export const updateOrder = (id, data) => {
  return put(`/orders/${id}`, data);
};

//  Delete a order 
export const deleteOrder = (id) => {
  return del(`/orders/${id}`);
};

// Update order status for kitchen 
export const updateStatus = (id, newStatus, extraParams = {}) => {
  return put(`/orders/${id}/status`, { status: newStatus, ...extraParams });
};

export const cancelOrder = (orderId, cancelRemarks, cancelAttachment = null) => {
  const formData = new FormData();
  formData.append('cancel_remarks', cancelRemarks);
  if (cancelAttachment) {
    formData.append('cancel_attachment', cancelAttachment);
  }
  return post(`/orders/${orderId}/cancel`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};
// xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx Delete approval  request xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx

export const getAllDeleteRequest = (data) =>{
  return get(`/orders/pending-cancel-requests`, data)
}

export const approveDeleteRequest = (id, data = {}) => {
  return put(`/orders/${id}/approve-cancel`, data);
}

export const rejectDeleteRequest = (id, rejectionReason = "") => {
  return put(`/orders/${id}/reject-cancel`, { rejection_reason: rejectionReason });
}




// xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx Pdf methods xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx

export const getOrderPDF = (id) => {
  return get(`/orders/${id}/pdf`, {
    responseType: 'blob', 
  });
};

export const downloadOrderPDF = async (id) => {
  return await get(`/orders/${id}/pdf`, {
    responseType: 'blob', 
  });
};



// xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx Invoice Check xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx

export const checkInvoiceNumber = (data) => {
  return post('/orders/check-invoice-number', data);
};



// xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx Reports xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx

export const getAllReports = (params = {}) => {
  const query = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      query.append(key, value);
    }
  });

  return get(`reports/orders?${query.toString()}`);
};

//  Export Orders Report
export const exportOrdersReport = (params = {}) => {
  const query = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      query.append(key, value);
    }
  });

  return get(`/reports/orders/export?${query.toString()}`, {
    responseType: 'blob',
  });
};

//  Export Today's Orders
export const exportTodayOrdersExcel = () => {
  return get('/orders/today-orders/export-excel', {
    responseType: 'blob',
  });
};

//  Export Today's Cake Orders
export const exportTodayCakeOrdersExcel = () => {
  return get('/orders/today-cake-orders/export-excel', {
    responseType: 'blob',
  });
};

// Export Filtered Orders Excel
export const exportFilteredOrdersExcel = (params = {}) => {
  const query = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      query.append(key, value);
    }
  });

  return get(`/orders-export-csv?${query.toString()}`, {
    responseType: 'blob',
  });
};

// xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx Generate Order Number based on Branch + OrderType xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx

export const generateOrderNumber = (data) => {
  return post('/orders/generate-order-number', data);
};

// xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx Order Edit History xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx

export const getOrderChangeHistory = (orderId) => {
  return get(`/orders/${orderId}/change-history`);
};

export const getOrderShareLink = (id) => {
  return get(`/orders/${id}/share-link`);
};

// xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx Kitchen module xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx



export const getAllSweetOrders = (params = {}) => {
  const query = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      query.append(key, value);
    }
  });

  return get(`/kitchen/sweet-orders?${query.toString()}`);
};

export const getAllCakeOrder = (params = {}) => {
  const query = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      query.append(key, value);
    }
  });

  return get(`/kitchen/cake-orders?${query.toString()}`);
};

export const getKitchenReports = (params = {}) => {
  const query = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      query.append(key, value);
    }
  });

  return get(`/kitchen/reports?${query.toString()}`);
};